// extracted by mini-css-extract-plugin
export default {"myHeader":"quyk7dZsL8ludTEawFh5","search":"VJA3r8AAAOw3V6YxNInH","myTabs":"gwW4BX5MBt_SNdsCFtgF"};